import { actionTypeConstants } from "../utils";
function valuationReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case actionTypeConstants.SELECTED_VALUATION_OPTIONS:
      return {
        ...state,
        selectedValuationOptions: {
          ...action.payload
        }
      };
    case actionTypeConstants.UPDATE_SHIPMENT_VALUE:
      return {
        ...state,
        shipmentValue: action?.payload?.shipmentValue
      };
    case actionTypeConstants.DEFAULT_SHIPMENT_VALUE:
      return {
        ...state,
        defaultShipmentValue: action?.payload?.defaultShipmentValue
      };
    case actionTypeConstants.SHIPPER_DECLARED_VALUE:
      return {
        ...state,
        shipperDeclaredValue: action?.payload?.shipperDeclaredValue,
        shipperDeclaredLabel: action?.payload?.shipperDeclaredLabel,
      };
    case actionTypeConstants.UPDATE_DEDUCTIBLE_OPTIONS:
      return {
        ...state,
        deductibleOptions: [
          ...action?.payload?.deductibleOptions
        ]
      };
      case actionTypeConstants.UPDATE_SELECTED_OPTIONS_DATA:
      return {
        ...state,
        selectedOptionData:action?.payload?.selectedOption
        
      };

    default:
      return state;
  }

}

export default valuationReducer;
